<template>
	<el-menu @select="indexAssigment" :default-active="activeIndex" class="nav" :collapse="true">
		<el-menu-item :index="workflowPath">
			<i class="icon-workflow scaleIcon"></i>
			<span slot="title">Workflow</span>
		</el-menu-item>
		<el-menu-item id="wf-tour-executions-tab" :index="executionsPath">
			<i style="font-weight: 800; font-size: 23px" class="icon-lightning scaleIcon"></i>
			<span slot="title">Executions</span>
		</el-menu-item>
	</el-menu>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
	data() {
		return {
			activeIndex: this.$route.name,
			doNotRefire: false,
		};
	},
	watch: {
		"$route.name": function () {
			this.activeIndex = this.$route.name;
		},
		activeIndex: {
			handler(newVal, prevVal) {
				this.$nextTick(() => {
					//Hack to ensure route is not highlighted unless changes have been saved or void
					if (!this.doNotRefire) {
						if (this.returnUnsavedChangesPresent) {
							this.doNotRefire = true;
							this.activeIndex = prevVal;

							this.$confirm(
								"You have unsaved integration connection changes. Continue?",
								"Warning",
								{
									confirmButtonText: "OK",
									cancelButtonText: "Cancel",
									type: "warning",
								}
							)
								.then(() => {
									this.updateUnsavedChangesStateMETHOD(false);
									this.handleSelect(newVal);
								})
								.catch(() => { });
						} else {
							this.handleSelect(newVal);
						}
					} else {
						this.doNotRefire = false;
					}
				});
			},
			deep: true,
		},
	},
	computed: {
		...mapGetters(["returnUnsavedChangesPresent"]),
		workflowPath() {
			return "workflow";
		},
		executionsPath() {
			return "executions";
		},
	},
	methods: {
		...mapActions([
			"updateUnsavedChangesStateMETHOD"
		]),

		indexAssigment(key) {
			this.activeIndex = key;
		},

		handleSelect(key) {
			let routePath;

			if (key === "workflow") {
				routePath = `/workflows/${this.$route.params.workflowId}/${this.$route.params.name}`;
			} else {
				routePath = `/workflows/${this.$route.params.workflowId}/${this.$route.params.name}/executions`;
			}
			this.activeIndex = key;
			this.$router.push(routePath).catch(() => {
				return;
			});
		},
	},
};
</script>

<style scoped lang="scss">
@import "../theme/baseStyles/index.scss";

.nav {
	padding-top: 20px;
	height: calc(100% - 20px);
	width: 79px !important;
	background-color: white !important;
	border-right: 1px solid #e9e9eb;
	text-align: center;
}

.nav>.el-menu-item:focus,
.el-menu-item:hover {
	background-color: transparent !important;
}

.nav>.el-menu-item.is-active i {
	background: $--color-primary;
	border-radius: 4px;
	padding: 10px;
	color: white !important;
}

.nav>.el-menu-item :focus,
.el-menu-item :hover {
	color: #210f3c !important;
}

.scaleIcon {
	font-size: 20px;
}

.nav>>>.el-menu-item.is-disabled {
	opacity: 0.4;
	cursor: not-allowed;
}
</style>
